'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfileMenu = undefined;

var _UserProfileMenu2 = require('./UserProfileMenu');

var _UserProfileMenu3 = _interopRequireDefault(_UserProfileMenu2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.UserProfileMenu = _UserProfileMenu3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserProfileMenu/index.js
// module id = 1785
// module chunks = 0